/**
 * importData — per-entity import rules (task 35.02 §5).
 *
 * Read by both sides: the server refuses a format an entity does not accept,
 * and the import dialog narrows its file picker to the same list, so the user
 * never gets to choose a file that will be rejected.
 *
 * An entity with no entry accepts every importable format. This map is for the
 * exceptions.
 *
 * **Documents are JSON only.** An invoice, quote or purchase order is a header
 * plus lines, and a CSV row cannot carry the lines — a CSV import of one would
 * silently produce a header whose totals then recompute to zero. JSON carries
 * the nested structure natively, which is the shape these entities actually
 * have. Header-only fields still import from JSON today; the lines themselves
 * are the `granularity: 'lines'` work in §11.1.
 *
 * `nested` opts specific array or object fields into being importable, as whole
 * values. Invoice lines carry no id — the line schema is itemId, itemName and
 * quantities, with no key, and nothing in arrayKeys declares one — so there is
 * nothing to match a line on and no way to diff element by element. The array
 * is therefore the unit: it compares whole, changes whole, and is approved
 * whole. Everything derived from it (vatTaxes, the totals) is recomputed by
 * logicData on write, which is why only `lines` is listed and not its results.
 *
 * A field absent from the file still means leave it alone, so a header-only
 * import never disturbs the lines.
 *
 * Note what this does *not* control: whether a document can be imported as
 * booked. It cannot, and nothing here says so — `operationData` already
 * declares which fields an operation owns (`state`, `archived`, `completed`,
 * `status`), and import refuses to set any of them. Import creates drafts;
 * booking stays an operation.
 */
export const importData = {
    invoice:       { formats: ['json'], nested: ['lines'] },
    purchaseOrder: { formats: ['json'], nested: ['lines'] },
    quote:         { formats: ['json'], nested: ['lines'] }
}

/** The formats an entity accepts, or null when it accepts all of them. */
export const importFormatsFor = (endpoint) => importData[endpoint]?.formats || null

export default importData
